import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { setFeature } from "@aws-sdk/core";
var ACCOUNT_ID_ENDPOINT_REGEX = /\d{12}\.ddb/;
export function checkFeatures(_x, _x2, _x3) {
  return _checkFeatures.apply(this, arguments);
}
function _checkFeatures() {
  _checkFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, config, args) {
    var _request$headers, _context$__smithy_con, _context$__smithy_con2;
    var request, retryStrategy, _retryStrategy$constr, _retryStrategy$constr2, _endpointV2$url, _config$accountIdEndp, endpointV2, identity, credentials, _i, _Object$entries, _credentials$$source, _Object$entries$_i, key, value;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            request = args.request;
            if ((request === null || request === void 0 ? void 0 : (_request$headers = request.headers) === null || _request$headers === void 0 ? void 0 : _request$headers["smithy-protocol"]) === "rpc-v2-cbor") {
              setFeature(context, "PROTOCOL_RPC_V2_CBOR", "M");
            }
            if (!(typeof config.retryStrategy === "function")) {
              _context.next = 7;
              break;
            }
            _context.next = 5;
            return config.retryStrategy();
          case 5:
            retryStrategy = _context.sent;
            if (typeof retryStrategy.acquireInitialRetryToken === "function") {
              if ((_retryStrategy$constr = retryStrategy.constructor) !== null && _retryStrategy$constr !== void 0 && (_retryStrategy$constr2 = _retryStrategy$constr.name) !== null && _retryStrategy$constr2 !== void 0 && _retryStrategy$constr2.includes("Adaptive")) {
                setFeature(context, "RETRY_MODE_ADAPTIVE", "F");
              } else {
                setFeature(context, "RETRY_MODE_STANDARD", "E");
              }
            } else {
              setFeature(context, "RETRY_MODE_LEGACY", "D");
            }
          case 7:
            if (!(typeof config.accountIdEndpointMode === "function")) {
              _context.next = 21;
              break;
            }
            endpointV2 = context.endpointV2;
            if (String(endpointV2 === null || endpointV2 === void 0 ? void 0 : (_endpointV2$url = endpointV2.url) === null || _endpointV2$url === void 0 ? void 0 : _endpointV2$url.hostname).match(ACCOUNT_ID_ENDPOINT_REGEX)) {
              setFeature(context, "ACCOUNT_ID_ENDPOINT", "O");
            }
            _context.next = 12;
            return (_config$accountIdEndp = config.accountIdEndpointMode) === null || _config$accountIdEndp === void 0 ? void 0 : _config$accountIdEndp.call(config);
          case 12:
            _context.t0 = _context.sent;
            _context.next = _context.t0 === "disabled" ? 15 : _context.t0 === "preferred" ? 17 : _context.t0 === "required" ? 19 : 21;
            break;
          case 15:
            setFeature(context, "ACCOUNT_ID_MODE_DISABLED", "Q");
            return _context.abrupt("break", 21);
          case 17:
            setFeature(context, "ACCOUNT_ID_MODE_PREFERRED", "P");
            return _context.abrupt("break", 21);
          case 19:
            setFeature(context, "ACCOUNT_ID_MODE_REQUIRED", "R");
            return _context.abrupt("break", 21);
          case 21:
            identity = (_context$__smithy_con = context.__smithy_context) === null || _context$__smithy_con === void 0 ? void 0 : (_context$__smithy_con2 = _context$__smithy_con.selectedHttpAuthScheme) === null || _context$__smithy_con2 === void 0 ? void 0 : _context$__smithy_con2.identity;
            if (identity !== null && identity !== void 0 && identity.$source) {
              credentials = identity;
              if (credentials.accountId) {
                setFeature(context, "RESOLVED_ACCOUNT_ID", "T");
              }
              for (_i = 0, _Object$entries = Object.entries((_credentials$$source = credentials.$source) !== null && _credentials$$source !== void 0 ? _credentials$$source : {}); _i < _Object$entries.length; _i++) {
                _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                setFeature(context, key, value);
              }
            }
          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _checkFeatures.apply(this, arguments);
}